module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-suggestion.daf84b9d.png";